import _ from "lodash";
import { Link } from "react-router-dom";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';
import {
  Repeat,
} from "lucide-react";
import { useHubAssinatura } from "../../store/hub/useHubAssinatura";
import { useMemo } from "react";

export function Signatures() {

  const assinaturaDetails = useHubAssinatura(state => state.data.details);

  const assinaturasAtivas = useMemo(() => {
    return _.compact([
      (!!assinaturaDetails.ativo?.basico && { name: 'Básico', value: assinaturaDetails.ativo.basico, color: '#dbbc9e' }),
      (!!assinaturaDetails.ativo?.essencial && { name: 'Essencial', value: assinaturaDetails.ativo.essencial, color: '#ccd259' }),
      (!!assinaturaDetails.ativo?.ilimitado && { name: 'Ilimitado', value: assinaturaDetails.ativo.ilimitado, color: '#ed5c00' }),
      (!!assinaturaDetails.ativo?.black && { name: 'Black', value: assinaturaDetails.ativo.black, color: '#525252' }),
    ])
  }, [assinaturaDetails?.ativo])

  const assinaturasCanceladas = useMemo(() => {
    return _.compact([
      (!!assinaturaDetails.cancelado?.basico && { name: 'Básico', value: assinaturaDetails.cancelado.basico, color: '#f30000' }),
      (!!assinaturaDetails.cancelado?.essencial && { name: 'Essencial', value: assinaturaDetails.cancelado.essencial, color: '#9b1b1b' }),
      (!!assinaturaDetails.cancelado?.ilimitado && { name: 'Ilimitado', value: assinaturaDetails.cancelado.ilimitado, color: '#d45353' }),
      (!!assinaturaDetails.cancelado?.black && { name: 'Black', value: assinaturaDetails.cancelado.black, color: '#610c0c' }),
    ])
  }, [assinaturaDetails?.cancelado])

  return (
    <div className="w-full rounded-lg border-zinc-200/30 shadow-md border p-4 gap-2 flex flex-col sm:col-span-3 sm:row-span-8 md:col-span-2 md:row-span-5 lg:col-span-3 lg:row-span-5 xl:col-span-5 xl:row-span-7 bg-white">
      <div className="w-full flex">
        <Link to="/assinaturas?tab=assinantes" className="flex gap-2 text-scale-500 font-semibold text-lg items-center">
          <Repeat /> Assinaturas
        </Link>
      </div>
      <div className="w-full h-full flex flex-col gap-1">
        <div className="w-full flex-1 flex gap-0 items-center">
          <div className="flex-1 h-44 w-full min-w-60 [&_*]:outline-none">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Tooltip />
                <Pie data={assinaturasAtivas} dataKey="value" cx="50%" cy="50%" innerRadius={50} outerRadius={70} fill="#ff00ff" label >
                  {assinaturasAtivas.map((entry) => (
                    <Cell key={`cell-${entry.name}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex-1 h-44 w-full min-w-60 [&_*]:outline-none">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Tooltip />
                <Pie data={assinaturasCanceladas} dataKey="value" cx="50%" cy="50%" innerRadius={50} outerRadius={70} fill="#ff00ff" label >
                  {assinaturasCanceladas.map((entry) => (
                    <Cell key={`cell-${entry.name}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="flex w-full gap-4 items-center text-base font-medium py-2">
          <p className="flex-1 items-center justify-center text-center text-zinc-700">Ativos</p>
          <p className="flex-1 items-center justify-center text-center text-zinc-700">Cancelados</p>
        </div>
      </div>
    </div>
  );
}
